(function ($, window, document, undefined) {
	$(function () {
		/**
		 * Check WebP support
		 */
		function support_format_webp() {
			const elem = document.createElement('canvas');

			if (!!(elem.getContext && elem.getContext('2d'))) {
				// was able or not to get WebP representation
				document.querySelector('body').classList.add("kp-webp-supported");
			} else {
				// very old browser like IE 8, canvas not supported
				document.querySelector('body').classList.add("kp-no-webp");
			}
		}

		/**
		 * Hero slider
		 */
		function heroSlider() {

			const heroSliderOptions = {
				infinite: true,
				speed: 500,
				slidesToShow: 1,
				slidesToScroll: 1,
				prevArrow: `<button type="button" class="slick-prev" aria-label="Prev slide">
						<svg width="64" height="64" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
						  <g stroke-width="0"/>
						  <g stroke-linecap="round" stroke-linejoin="round"/>
						  <path d="M9 4v7L4.5 7.5 9 4Z" fill="#000"/>
					</svg>
				</button>`,
				nextArrow: `<button type="button" class="slick-next" aria-label="Next slide">
					<svg width="64" height="64" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
					  <g stroke-width="0"/>
					  <g stroke-linecap="round" stroke-linejoin="round"/>
					  <path d="M6 11V4l4.5 3.5L6 11Z" fill="#000"/>
					</svg>
				</button>`,
				dots: false,
				fade: true,
			};

			const heroSlider = $(".kp-hero-slider");

			$(heroSlider).slick(heroSliderOptions);

			// $(heroSlider).on("click", function(e) {
			// 	const target = e.target;

			// 	if ($(target).closest(".kp-hero-images").length !== 0) {
			// 		const link = $(target).closest(".kp-hero-images").data("link");
			// 		const linkTarger = $(target).closest(".kp-hero-images").data("target");
			// 		const lieAnchor= document.createElement('a');
			// 		if( linkTarger ) {
			// 			lieAnchor.target= linkTarger;
			// 		}
			// 		lieAnchor.href= link;
			// 		lieAnchor.click();
			// 	}
			// });
		}

		function accessoriesSlider() {
			$(".kp-accessories .wcpscwc-product-slider .products").slick({
				arrows: false,
				dots: true,
				slidesToShow: 4,
				responsive: [
					{
						breakpoint: 992,
						settings: {
							arrows: false,
							dots: true,
							slidesToShow: 3,
						},
					},
					{
						breakpoint: 768,
						settings: {
							arrows: false,
							dots: true,
							slidesToShow: 2,
							slidesToScroll: 2,
						},
					},
					{
						breakpoint: 767,
						settings: {
							arrows: false,
							dots: true,
							slidesToShow: 2,
							slidesToScroll: 2,
						},
					},
					{
						breakpoint: 576,
						settings: {
							arrows: false,
							dots: true,
							slidesToShow: 1,
							slidesToScroll: 1,
						},
					},
				],
			});
		}

		/**
		 * Slider initializer
		 */
		function initializeSliderHandler(mobileSlider = null, regularSlider = null, mobileSliderWidth, carousel, mobileOptions = null, regularOptions = null) {
			if (carousel.length !== 0) {
				if (mobileSlider && !regularSlider) {
					// slick only on mobile
					if ($(window).width() > mobileSliderWidth) {
						if (carousel.hasClass('slick-initialized')) {
							carousel.slick('unslick');
						}
					} else {
						if (!carousel.hasClass('slick-initialized')) {
							carousel.slick(mobileOptions);
						}
					}
				} else if (regularSlider && !mobileSlider) {
					// slick only on desktop
					if ($(window).width() <= mobileSliderWidth) {
						if (carousel.hasClass('slick-initialized')) {
							carousel.slick('unslick');
						}
					} else {
						if (!carousel.hasClass('slick-initialized')) {
							carousel.slick(regularOptions);
						}
					}
				} else if (regularSlider && mobileSlider) {
					// slick for desktop & mobile
					if (!carousel.hasClass('slick-initialized')) {
						carousel.slick(regularOptions);
					}
				}
			}
		}

		/**
		 * Shop by category slider
		 */
		function shopByCategorySlider() {
			const mobileSlider = Boolean($(".kp-shop-by-category.use-mobile-slider").length);
			const mobileCarouselSelector = $("[class='kp-shop-by-category use-mobile-slider'] .kp-shop-category-wrap");
			let resizeTimeout;

			const mobileOptions = {
				arrows: false,
				dots: true,
				mobileFirst: true,
				useTransform: false,
				speed: 300,
			};

			initializeSliderHandler(mobileSlider, null, 575, mobileCarouselSelector, mobileOptions);

			$(window).on("resize", function () {
				// Debounced resize
				clearTimeout(resizeTimeout);

				resizeTimeout = setTimeout(function () {
					initializeSliderHandler(mobileSlider, null, 575, mobileCarouselSelector, mobileOptions);

					clearTimeout(resizeTimeout);
				}, 100);
			});
		}

		/**
		 *  Picks slider
		 */
		function picksSlider() {
			const regularSlider = Boolean($(".kp-picks.use-desktop-slider").length);
			const mobileSlider = Boolean($(".kp-picks.use-mobile-slider").length);
			const desktopCarouselSelector = $("[class='kp-picks use-desktop-slider'] .kp-picks-slider > .products");
			const regularCarouselSelector = $("[class='kp-picks use-desktop-slider use-mobile-slider'] .kp-picks-slider > .products");

			let resizeTimeout;

			const picksOptions = {
				autoplay: true,
				swipeToSlide: true,
				prevArrow: `<button type="button" class="slick-prev" aria-label="Prev slide">
					<svg width="36" height="42" viewBox="0 0 36 42" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M0.431532 20.3107L35.9386 0.773308L35.1913 41.1487L0.431532 20.3107Z" fill="black"/>
					</svg>
				</button>`,
				nextArrow: `<button type="button" class="slick-next" aria-label="Next slide">
					<svg width="37" height="41" viewBox="0 0 37 41" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M36.1607 20.3127L1.29445 40.972L0.75433 0.593296L36.1607 20.3127Z" fill="black"/>
					</svg>
				</button>`,
				slidesToShow: 2.99,
				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 1.99,
						},
					},
				],
			};

			const picksOptionsAlternative = {
				...picksOptions,
				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 1.99,
						},
					},
					{
						breakpoint: 576,
						settings: {
							slidesToShow: 1,
							arrows: false,
							dots: true,
							useTransform: false,
							speed: 300,
						},
					},
				]
			};

			initializeSliderHandler(mobileSlider, regularSlider, 575, desktopCarouselSelector, null, picksOptions);
			initializeSliderHandler(mobileSlider, regularSlider, 575, regularCarouselSelector, null, picksOptionsAlternative);

			$(window).on("resize", function () {
				// Debounced resize
				clearTimeout(resizeTimeout);

				resizeTimeout = setTimeout(function () {
					initializeSliderHandler(mobileSlider, regularSlider, 575, desktopCarouselSelector, null, picksOptions);
					initializeSliderHandler(mobileSlider, regularSlider, 575, regularCarouselSelector, null, picksOptionsAlternative);

					clearTimeout(resizeTimeout);
				}, 100);
			});
		}

		/**
		 * Accessories & clothing slider
		 */
		function acSlider() {
			let resizeTimeout;
			let isInited = false;
			let isInitedIntervalId;
			clearInterval(isInitedIntervalId);

			// reassignOptions();

			function setHeightForTitles() {
				let slides = $(".kp-accessories .wcpscwc-product-slider .slick-slider .slick-slide");
				let itemHeight = 0;

				slides.each(function (_slideItemIndex, slideItem) {
					let firstTitleHeight = $(slideItem).find(".woocommerce-loop-product__title").eq(0).outerHeight();

					itemHeight = Math.max(firstTitleHeight, itemHeight);
				});

				$(slides).find(".woocommerce-loop-product__title").css({
					"min-height": `${itemHeight}px`,
				});
			}

			function resizeSlide() {
				if (!isInited) {
					return;
				}

				let widthProp = ($(".kp-accessories .wcpscwc-product-slider .slick-slider .slick-slide").attr("style"));

				widthProp = widthProp.slice(0, -1);
				widthProp = widthProp.slice(7);

				$(":root")[0].style.setProperty("--slide-width", `${widthProp}`);
			}

			// function reassignOptions() {
			// 	isInitedIntervalId = setInterval(function () {
			// 		if ($(".kp-accessories .wcpscwc-product-slider .products").hasClass("slick-initialized") && !isInited) {
			// 			isInited = true;

			// 			$(".kp-accessories .wcpscwc-product-slider .products").slick("slickSetOption", {
			// 				arrows: false,
			// 				dots: true,
			// 				slidesToShow: 4,
			// 				responsive: [
			// 					{
			// 						breakpoint: 992,
			// 						settings: {
			// 							arrows: false,
			// 							dots: true,
			// 							slidesToShow: 3,
			// 						},
			// 					},
			// 					{
			// 						breakpoint: 768,
			// 						settings: {
			// 							arrows: false,
			// 							dots: true,
			// 							slidesToShow: 2,
			// 							slidesToScroll: 2,
			// 						},
			// 					},
			// 					{
			// 						breakpoint: 767,
			// 						settings: {
			// 							arrows: false,
			// 							dots: true,
			// 							slidesToShow: 2,
			// 							slidesToScroll: 2,
			// 						},
			// 					},
			// 					{
			// 						breakpoint: 576,
			// 						settings: {
			// 							arrows: false,
			// 							dots: true,
			// 							slidesToShow: 1,
			// 							slidesToScroll: 1,
			// 						},
			// 					},
			// 					{
			// 						breakpoint: 560,
			// 						settings: {
			// 							arrows: false,
			// 							dots: true,
			// 							slidesToShow: 1,
			// 							slidesToScroll: 1,
			// 						},
			// 					},
			// 				],
			// 			}, true);

			// 			resizeSlide();

			// 			clearInterval(isInitedIntervalId);
			// 		}
			// 	}, 300);
			// }

			$(window).on("resize", function () {
				// Debounced resize
				clearTimeout(resizeTimeout);

				resizeTimeout = setTimeout(function () {
					// reassignOptions();
					resizeSlide();
					setHeightForTitles();

					clearTimeout(resizeTimeout);
				}, 100);
			});

			$(window).trigger("resize");
		}

		/**
		 * Best of KP equal titles height
		 */
		function setHeightForBestOfTitles() {
			let bestOfSliders = $(".kp-best-of-tabs-slider");

			bestOfSliders.each(function (_sliderIndex, sliderItem) {
				let itemHeight = 0;

				$(sliderItem).find(".kp-best-of-tabs-slider__item-title").each(function (sliderTitleIndex, sliderTitleItem) {
					let firstTitleHeight = $(sliderTitleItem).outerHeight();

					itemHeight = Math.max(firstTitleHeight, itemHeight);
				});

				$(sliderItem).find(".kp-best-of-tabs-slider__item-title").css({
					"min-height": `${itemHeight}px`
				});
			});
		}

		/**
		 * Best of KP slider
		 */
		function bestOfKpSlider() {
			const bestOfOptions = {
				arrows: false,
				dots: true,
				autoplay: true,
				swipeToSlide: true,
				slidesToShow: 4.99,
				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 3,
						},
					},
					{
						breakpoint: 576,
						settings: {
							swipeToSlide: false,
							slidesToShow: 2,
							useTransform: false,
							speed: 300,
						},
					},
				],
			};
			let resizeTimeout;

			$(".kp-best-of-tabs-slider").eq(0).slick(bestOfOptions);

			$(window).on("resize", function () {
				// Debounced resize
				clearTimeout(resizeTimeout);

				resizeTimeout = setTimeout(function () {
					$(".kp-best-of-tabs-slider").find(".kp-best-of-tabs-slider__item-title").css({
						"min-height": "0",
					});
					setHeightForBestOfTitles();

					clearTimeout(resizeTimeout);
				}, 200);
			});

			$(window).trigger("resize");
		}

		/**
		 * Best of KP tabs
		 */
		function tabs() {
			// Show first tab content by default
			$(".kp-best-of-tabs__content:first-of-type").show();

			// Default slider options
			let bestOfOptions = {
				arrows: false,
				dots: true,
				autoplay: true,
				swipeToSlide: true,
				slidesToShow: 4.99,
				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 3,
						},
					},
					{
						breakpoint: 576,
						settings: {
							swipeToSlide: false,
							slidesToShow: 2,
							useTransform: false,
							speed: 300,
						},
					},
				],
			};

			$(".kp-best-of-tabs").on("click", ".kp-best-of-tabs-caption__item:not(.kp-best-of-tabs__mobile-caption.active)", function (e) {
				e.preventDefault();
				// Tab index needs for the reference on the slider
				let tabIndex;
				let tabHref;
				let tabId;

				// Checking the clicked element
				// Get clicked "li" index
				tabIndex = $(this).index();
				// Get clicked "li" "a" href
				tabHref = $(this).find("a").attr("href");
				// Get clicked "li" "a" href to transform it into id
				tabId = $(this).find("a").attr("href");

				tabId = tabId.slice(1);

				// Remove class from li element (desktop tabs navigation) and its a element
				$(`.kp-best-of-tabs a[href*="#tab-"]`).closest(".kp-best-of-tabs-caption__item").removeClass("active");
				$(`.kp-best-of-tabs a[href*="#tab-"]`).closest(".kp-best-of-tabs-caption__item").find("a").removeClass("active");

				// Add class to the activated li element (desktop tabs navigation)
				$(`.kp-best-of-tabs a[href="${tabHref}"]`).closest(".kp-best-of-tabs-caption__item").addClass("active");


				// Check if the slider was initialized earlier. If it was not - initialize. If it was - refresh
				if (!$(".kp-best-of-tabs-slider").eq(tabIndex).hasClass("slick-initialized")) {
					$(".kp-best-of-tabs-slider").eq(tabIndex).slick(bestOfOptions);
					setHeightForBestOfTitles();
				}

				// Hide all tabs content
				$(".kp-best-of-tabs__content").removeClass("active");

				// Show proper tab content
				$(`.kp-best-of-tabs__content#${tabId}`).addClass("active");
			});
		}

		/**
		 * Custom video button
		 */
		function customVideoButton() {
			$(document).on("click touchstart", ".kp-video__button", function () {
				$(".kp-video").addClass("kp-video_play");

				const playTimeout = setTimeout(function () {
					const player = new Vimeo.Player($(".kp-video__video iframe"));
					player.play();

					clearTimeout(playTimeout);
				}, 350);
			});
		}

		function init() {
			tabs();
			customVideoButton();
		}

		init();

		// Init sliders after document is ready
		$(document).ready(function () {
			heroSlider();
			support_format_webp();
			shopByCategorySlider();
			picksSlider();
			bestOfKpSlider();
			accessoriesSlider();
			acSlider();
		});
	});
})(jQuery, window, document);
